// extracted by mini-css-extract-plugin
module.exports = {"icon":"autocomplete_icon-module__icon--1KLq_"};